<template>
  <v-card class="mx-auto overflow-visible " width="800px" style="margin-top: 0px; margin-bottom: 0px;z-index: 99" outlined>
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible d-block">
        <v-row class="align-center">
          <v-col cols="10">
            <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon aria-label="Close" @click="closeMenuPopup">mdi-close</v-icon>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="12" md="6">
                <common-range-picker
                  :clearable="true"
                  :aLight="'right'"
                  v-model="filterForm.dateTime"
                  class="'show-date"
                  label="Tìm kiếm theo ngày"
                  :class="this.currentPicker === 1 ? 'show-date' : 'hide-date'"
                  @show-date-picker="showDate(1)"
                ></common-range-picker>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="text-center mb-4">
          <v-btn class="primary mx-2" @click="searchContact">
            <v-icon>mdi-magnify</v-icon>Tìm kiếm nâng cao
          </v-btn>
          <v-btn
            class="primary mx-2"
            v-if="checkAuthorization('operator_download')"
            @click="downloadExcel(filterForm)"
          >
            <v-icon>mdi-download</v-icon>Download
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
export default {
  name: 'ContactStatusFilterForm',
  props: ['filter', 'filterForm', 'testerOrOperatorList', 'checkRoute', 'dateInvite', 'listTesters', 'listCase', 'listSaleInviteTest'],
  data() {
    return {
      types: [{ id: 1, name: 'Test' }, { id: 2, name: 'Phỏng vấn' }],
      subjects: [{ id: 1, name: 'Toán' }, { id: 3, name: 'Tiếng anh' }],
      searchInput: null,
      searchDateTest: null,
      currentPicker: null,
      // testerOrOperatorListAfter:null
    };
  },
  created() {

  },
  computed: {

  },
  methods: {
    closeMenuPopup() {
      this.filter.closeMenu = false;
    },
    searchContact() {
      Bus.$emit('confirm-list-filter', this.filterForm);
      Bus.$emit('reset-paging-filter');
    },
    showDate(index) {
      this.currentPicker = index;
    },
    // check bo loc ko duoc de trong
    checkIsEmpty(filterForm) {
      // khoi tao bien check rong
      let isDateTime = true;
      let isType = true;
      let isCaseTypeIds = true;
      let isCreatedAt = true;
      let isCreatedBy = true;
      let isInterviewUser = true;
      let isListInterviews = true;
      let isOperatorOrTesterId = true;
      let isSearchInfo = true;
      let isSelectedShift = true;
      let isStatus = true;
      let isSubjectId = true;

      // chay dieu kien check rong
      if (filterForm.dateTime && filterForm.dateTime.length === 0) isDateTime = false;
      if (filterForm.type == null) isType = false;
      if (filterForm.caseTypeIds && filterForm.caseTypeIds.length === 0) isCaseTypeIds = false;
      if (filterForm.createdAt && filterForm.createdAt.length === 0) isCreatedAt = false;
      if (filterForm.createdBy && filterForm.createdBy.length === 0) isCreatedBy = false;
      if (filterForm.interviewUser && filterForm.interviewUser.length === 0) isInterviewUser = false;
      if (filterForm.listInterviews && filterForm.listInterviews.length === 0) isListInterviews = false;
      if (filterForm.operatorOrTesterId && filterForm.operatorOrTesterId.length === 0) isOperatorOrTesterId = false;
      if (filterForm.searchInfo === '') isSearchInfo = false;
      if (filterForm.selectedShift && filterForm.selectedShift.length === 0) isSelectedShift = false;
      if (filterForm.status === '') isStatus = false;
      if (filterForm.subjectId == null) isSubjectId = false;

      if (isDateTime || isType || isCaseTypeIds || isCreatedAt || isCreatedBy || isInterviewUser
        || isListInterviews || isOperatorOrTesterId || isSearchInfo || isSelectedShift || isStatus || isSubjectId) {
        return true;
      } return false;
    },
    async downloadExcel(filterForm) {
      const check = this.checkIsEmpty(filterForm);
      if (!check) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
        });
        return;
      }
      Bus.$emit('download-excel-filter', filterForm);
    },
  },
};
</script>
<style lang="css" scoped>
/deep/.hide-date .daterangepicker.dropdown-menu{
  display: none
}
/deep/.show-date .daterangepicker.dropdown-menu{
  display: block;
}
</style>
